import { connect } from 'react-redux'

import { showAddOrganizationModal } from '../AddOrganizationModal/duck/actions'
import AddOrganizationButton from './presentational'

export default connect(undefined, {
  onClick: showAddOrganizationModal,
})(AddOrganizationButton)
